import React, { useEffect, useState } from "react";
import InnoIcons from "InnoUI/innoicons";
import theme from "theme";
import SmartBlub from "../../../../../assets/Smartbulb.png";
import DefaultBulb from "../../../../../assets/defaultbulb.png";
import { folderTypesMatch } from "utils/optionData/utils";
import SC from "./style";
import DeleteComponent from "views/AdminSettings/DeleteComponent";
import { apiGet, apiPost } from "api/callApi";
import { DetailDrawer, Popover, TableList } from "InnoUI/components";
import RolePermissions from "../../FolderPermissionAndStructure/RolePermissions";
import ViewRole from "../ViewRole";
import { allFolderType } from "utils/lookUpTable";
import { showAlert } from "utils/helper";

const Folder = (props) => {
  const {
    folder,
    addSubFolder,
    updateFolder = () => {},
    fetchData = () => {},
    popupState,
    handleEditModal = () => {},
    handleAddSubFolder = () => {},
    selectedProjects = [],
    selectedOccupants = [],
    changeLinkProject,
  } = props;
  const [isOpen, setIsOpen] = useState(true);
  const [openDeleteView, setOpenDeleteView] = useState(false);
  const [open, setOpen] = useState(false);

  const { REACT_APP_REPORT_COLUMNS } = process.env;
  const reportColumn = JSON.parse(REACT_APP_REPORT_COLUMNS);

  const toggleFolder = () => setIsOpen(!isOpen);

  const closeDrawer = () => {
    setOpen(false);
  };

  const openDeleteModal = () => {
    setOpenDeleteView(true);
  };

  const removeFolder = async (folderId) => {
    if (changeLinkProject) {
      const userConfirmed = await showAlert({
        title: "Are you sure?",
        text: "All selected project and occupant data will be lost.",
        icon: "warning",
        buttons: ["Cancel", "OK"],
        dangerMode: true,
      });

      if (!userConfirmed) {
        return;
      }
    }
    try {
      const response = await apiPost(`/v1/deletefolder/${folderId}`, {
        projectIds: selectedProjects,
        occupantIds: selectedOccupants,
      });
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      await fetchData();
      setOpenDeleteView(false);
    } catch (error) {
      showAlert({
        title: "Error",
        text: error.response?.data?.message,
        icon: "error",
      });

      console.log("Error: " + error);
    }
  };

  const handleOpenPermissions = () => {
    setOpen(true);
  };

  const folderType = folderTypesMatch.find(
    (item) => item.id === folder.folderType
  );
  const folderIcon = folderType ? folderType.icon : "📂";

  // canAccessfolderTypes.folder

  const isDeleteDisabled = (folder) => {
    console.log(folder, "kl");

    const nonDeletableTypes = new Set([
      allFolderType.Address_Book,
      allFolderType.Journal,
      allFolderType.Info,
      allFolderType.Photos,
    ]);

    // Type-based restriction
    if (nonDeletableTypes.has(folder.folderType)) return true;

    // Special rule for Documents with ReleasedOn
    if (
      folder.folderType === allFolderType.Document &&
      folder.reportColumnId === reportColumn.ReleasedOn
    ) {
      return true;
    }

    return false;
  };

  const menuItems = [
    ...(folder.folderType === allFolderType.Folder
      ? [
          {
            id: 1,
            text: "Add Sub folder",
            onClick: () => handleAddSubFolder(folder),
          },
        ]
      : []),

    // ...(folder.folderType == allFolderType.Document &&
    // folder.reportColumnId == reportColumn.ReleasedOn
    //   ? []
    //   : [
    //       {
    //         id: 2,
    //         text: "Edit",
    //         onClick: () => handleEditModal(folder),
    //       },
    //     ]),
    // ,

    {
      id: 2,
      text: "Edit",
      onClick: () => handleEditModal(folder),
    },

    ,
    {
      id: 3,
      text: "Permission To Folder",
      onClick: handleOpenPermissions,
    },
    ...(isDeleteDisabled(folder)
      ? []
      : [
          {
            id: 4,
            text: "Delete",
            onClick: openDeleteModal,
          },
        ]),
  ];

  return (
    <>
      <SC.FolderContainer>
        <SC.FolderHeader>
          <SC.FolderName>
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <SC.FolderIcon>{isOpen ? folderIcon : "📁"}</SC.FolderIcon>
              <SC.PopoverContainer>
                <span>{folder.sortOrder}</span>
                <SC.ValueSpanP>{folder.name || ""}</SC.ValueSpanP>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "5px",
                  }}
                >
                  <span className="lock-icon">
                    {folder.privacy === 1 ? (
                      <InnoIcons.LockIcon
                        sx={{
                          color: theme.colors.themeColor,
                          fontSize: "15px",
                        }}
                      />
                    ) : (
                      <InnoIcons.LockOpenIcon
                        sx={{ fontSize: "15px", opacity: 0.7 }}
                      />
                    )}
                  </span>
                  <span className="lock-icon">
                    <img
                      src={folder.isSmart === 0 ? DefaultBulb : SmartBlub}
                      alt=""
                      style={{ width: "15px", height: "15px" }}
                    />
                  </span>
                </div>
                <SC.PopoverSpan>
                  <Popover
                    sx={{
                      cursor: "pointer",
                    }}
                    buttonLabel={{
                      icon: <SC.MoreVertIcon />,
                    }}
                    popoverContent={
                      <TableList
                        sx={{
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                        }}
                        items={menuItems || []}
                        popupState={popupState}
                      />
                    }
                  />
                </SC.PopoverSpan>
              </SC.PopoverContainer>
            </div>

            <div>
              <ViewRole folder={folder} fetchData={fetchData} />
            </div>
          </SC.FolderName>
        </SC.FolderHeader>
        {isOpen && (
          <div className="folder-children">
            {folder.children.map((child) => (
              <Folder
                key={child.id}
                folder={child}
                addSubFolder={addSubFolder}
                removeFolder={removeFolder}
                updateFolder={updateFolder}
                handleEditModal={handleEditModal}
                handleAddSubFolder={handleAddSubFolder}
                fetchData={fetchData}
                selectedProjects={selectedProjects}
                selectedOccupants={selectedOccupants}
                changeLinkProject={changeLinkProject}
              />
            ))}
          </div>
        )}
      </SC.FolderContainer>

      {openDeleteView && (
        <DeleteComponent
          title={"Delete Folder"}
          messageData={`Are you sure you want to Delete this ${folder.name} `}
          setOpenDeleteView={setOpenDeleteView}
          openDeleteView={openDeleteView}
          handleDelete={() => removeFolder(folder.id)}
          handleArchive={() => setOpenDeleteView(false)}
          firstButtontext={"Cancel"}
          changeLinkProject={changeLinkProject}
        />
      )}

      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          width={"650px"}
          children={
            <RolePermissions
              onClose={closeDrawer}
              folder={folder}
              refreshFolders={fetchData}
              selectedProjects={selectedProjects}
              selectedOccupants={selectedOccupants}
            />
          }
        ></DetailDrawer>
      )}
    </>
  );
};

export default Folder;
